import { Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import * as _ from 'lodash';

/**
 * Commponent for generic text fields
 */
@Component({
  selector: '[app-form-field-checkbox]',
  templateUrl: './form-field-checkbox.component.html',
})
export class FormFieldCheckboxComponent implements OnInit, OnDestroy {
  @HostBinding('class.esf-form-item') public get formItemClass(): boolean {
    return true;
  }

  @Input() public label: string = '';
  @Input() public control: AbstractControl;
  @Output() public inputValueChange: EventEmitter<any> = new EventEmitter();
  public id: string;
  constructor() { }

  get formControl(): UntypedFormControl {
    return this.control as UntypedFormControl;
  }

  public ngOnInit(): void {
    const parent = this.control.parent;
    for (const key of Object.keys(parent.controls)) {
      const childControl = _.get(parent.controls, key);
      if (childControl === this.control) {
        this.id = key;
      }
    }
  }

  public emitValue(event: any): void {
    this.inputValueChange.emit(event.target.checked);
  }

  public ngOnDestroy(): void { }

}
